var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Selected Employee Name: "+_vm._s(_vm.getEmployeeName(_vm.activeUser)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }